import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorReporterComponent } from './error-reporter/error-reporter.component';
import { ErrorListItemComponent } from './error-reporter/error-list-item/error-list-item.component';
import { ErrorReporterService } from './error-reporter/error-reporter.service';
import { ReporterDialogComponent } from './error-reporter/reporter-dialog/reporter-dialog.component';
import { DomModule } from '../dom';



@NgModule({
  declarations: [
    ErrorReporterComponent,
    ErrorListItemComponent,
    ReporterDialogComponent,
  ],
  imports: [
    CommonModule,
    DomModule,
  ],
  exports: [
    ErrorReporterComponent,
  ],
  providers: [
    ErrorReporterService
  ],
})
export class NomidioDevelopmentModule { }
